// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./$.to-object');

require('./$.object-sap')('getPrototypeOf', function($getPrototypeOf){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.object.get-prototype-of.js
 ** module id = 237
 ** module chunks = 0
 **/